<div class="menu-wrapper">
  <button class="menu-trigger" [class.is-open]="isOpen()" (click)="toggle($event)" cdkOverlayOrigin #trigger="cdkOverlayOrigin">
    <i class="menu-dots"></i>
  </button>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isOpen()"
    [cdkConnectedOverlayPositions]="[
      { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top', offsetY: 8 },
      { originX: 'end', originY: 'top', overlayX: 'end', overlayY: 'bottom', offsetY: -8 }
    ]"
    [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
    (backdropClick)="close()"
  >
    <div class="dropdown-menu">
      @for (item of items(); track item.action) {
        <button class="dropdown-item" (click)="onItemClick(item.action, $event)">
          {{ item.label }}
        </button>
      }
    </div>
  </ng-template>
</div>
